import { PopupShare } from '@atlassian/learning-components';
import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

export const ShareArticleButton: React.FC = () => {
  const url = window.location.href;

  return (
    <div css={shareArticleStyles}>
      <p css={shareArticleTextStyles}>Share article</p>
      <PopupShare alignToLeft urlToShare={url} />
    </div>
  );
};

const shareArticleStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: token('space.050'),
});

const shareArticleTextStyles = css({
  color: token('color.text.subtle'),
  textAlign: 'center',
  fontFamily: 'Charlie Text',
  fontSize: '16px',
  fontWeight: token('font.weight.semibold'),
});
